import { BsFiletypeMp3 } from 'react-icons/bs';
import {
  FaFile,
  FaFileAudio,
  FaFileCode,
  FaFileExcel,
  FaFileImage,
  FaFileLines,
  FaFilePowerpoint,
  FaFileVideo,
  FaFileWord,
  FaFileZipper,
} from 'react-icons/fa6';
import {
  TbFileTypeBmp,
  TbFileTypeCss,
  TbFileTypeCsv,
  TbFileTypeDoc,
  TbFileTypeDocx,
  TbFileTypeHtml,
  TbFileTypeJpg,
  TbFileTypeJs,
  TbFileTypeJsx,
  TbFileTypePdf,
  TbFileTypePhp,
  TbFileTypePng,
  TbFileTypePpt,
  TbFileTypeRs,
  TbFileTypeSql,
  TbFileTypeSvg,
  TbFileTypeTs,
  TbFileTypeTsx,
  TbFileTypeTxt,
  TbFileTypeVue,
  TbFileTypeXls,
  TbFileTypeXml,
  TbFileTypeZip,
} from 'react-icons/tb';
import { getOfficeDocumentKind } from '../../layout/ReusableComponent/MobileMediaViewer/officeDocumentPreview';

const DEFAULT_FILE = { Icon: FaFile, modifierClass: 'sb-drive-icon--file' };

/** @type {Record<string, { Icon: import('react-icons').IconType; modifierClass: string }>} */
const FILE_ICON_BY_EXTENSION = {
  pdf: { Icon: TbFileTypePdf, modifierClass: 'sb-drive-icon--pdf' },

  jpg: { Icon: TbFileTypeJpg, modifierClass: 'sb-drive-icon--image' },
  jpeg: { Icon: TbFileTypeJpg, modifierClass: 'sb-drive-icon--image' },
  png: { Icon: TbFileTypePng, modifierClass: 'sb-drive-icon--image' },
  svg: { Icon: TbFileTypeSvg, modifierClass: 'sb-drive-icon--image' },
  bmp: { Icon: TbFileTypeBmp, modifierClass: 'sb-drive-icon--image' },
  gif: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  webp: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  heic: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  heif: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  tiff: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  tif: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  ico: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },
  avif: { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' },

  mp3: { Icon: BsFiletypeMp3, modifierClass: 'sb-drive-icon--audio' },
  m4a: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  aac: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  wav: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  flac: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  ogg: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  opus: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  aiff: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  aif: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },
  caf: { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' },

  mov: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  mp4: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  m4v: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  webm: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  mkv: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  avi: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  wmv: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  flv: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  mpg: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  mpeg: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },
  qt: { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' },

  doc: { Icon: TbFileTypeDoc, modifierClass: 'sb-drive-icon--word' },
  docx: { Icon: TbFileTypeDocx, modifierClass: 'sb-drive-icon--word' },
  xls: { Icon: TbFileTypeXls, modifierClass: 'sb-drive-icon--spreadsheet' },
  xlsx: { Icon: FaFileExcel, modifierClass: 'sb-drive-icon--spreadsheet' },
  xlsm: { Icon: FaFileExcel, modifierClass: 'sb-drive-icon--spreadsheet' },
  xlsb: { Icon: FaFileExcel, modifierClass: 'sb-drive-icon--spreadsheet' },
  csv: { Icon: TbFileTypeCsv, modifierClass: 'sb-drive-icon--spreadsheet' },
  ppt: { Icon: TbFileTypePpt, modifierClass: 'sb-drive-icon--presentation' },
  pptx: { Icon: FaFilePowerpoint, modifierClass: 'sb-drive-icon--presentation' },
  pptm: { Icon: FaFilePowerpoint, modifierClass: 'sb-drive-icon--presentation' },

  txt: { Icon: TbFileTypeTxt, modifierClass: 'sb-drive-icon--text' },
  md: { Icon: FaFileLines, modifierClass: 'sb-drive-icon--text' },
  markdown: { Icon: FaFileLines, modifierClass: 'sb-drive-icon--text' },
  log: { Icon: FaFileLines, modifierClass: 'sb-drive-icon--text' },
  rtf: { Icon: FaFileLines, modifierClass: 'sb-drive-icon--text' },

  zip: { Icon: TbFileTypeZip, modifierClass: 'sb-drive-icon--archive' },
  rar: { Icon: FaFileZipper, modifierClass: 'sb-drive-icon--archive' },
  '7z': { Icon: FaFileZipper, modifierClass: 'sb-drive-icon--archive' },
  tar: { Icon: FaFileZipper, modifierClass: 'sb-drive-icon--archive' },
  gz: { Icon: FaFileZipper, modifierClass: 'sb-drive-icon--archive' },
  bz2: { Icon: FaFileZipper, modifierClass: 'sb-drive-icon--archive' },

  html: { Icon: TbFileTypeHtml, modifierClass: 'sb-drive-icon--code' },
  htm: { Icon: TbFileTypeHtml, modifierClass: 'sb-drive-icon--code' },
  css: { Icon: TbFileTypeCss, modifierClass: 'sb-drive-icon--code' },
  js: { Icon: TbFileTypeJs, modifierClass: 'sb-drive-icon--code' },
  jsx: { Icon: TbFileTypeJsx, modifierClass: 'sb-drive-icon--code' },
  ts: { Icon: TbFileTypeTs, modifierClass: 'sb-drive-icon--code' },
  tsx: { Icon: TbFileTypeTsx, modifierClass: 'sb-drive-icon--code' },
  json: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  xml: { Icon: TbFileTypeXml, modifierClass: 'sb-drive-icon--code' },
  php: { Icon: TbFileTypePhp, modifierClass: 'sb-drive-icon--code' },
  sql: { Icon: TbFileTypeSql, modifierClass: 'sb-drive-icon--code' },
  vue: { Icon: TbFileTypeVue, modifierClass: 'sb-drive-icon--code' },
  rs: { Icon: TbFileTypeRs, modifierClass: 'sb-drive-icon--code' },
  py: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  java: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  c: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  cpp: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  h: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  go: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  rb: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  sh: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  yaml: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
  yml: { Icon: FaFileCode, modifierClass: 'sb-drive-icon--code' },
};

const AUDIO_EXT = /\.(mp3|m4a|aac|wav|flac|ogg|opus|aiff?|caf)$/i;
const VIDEO_EXT = /\.(mov|mp4|m4v|webm|mkv|avi|wmv|flv|mpg|mpeg|qt)$/i;
const IMAGE_EXT = /\.(png|jpe?g|gif|webp|svg|bmp|heic|heif|tiff?|ico|avif)$/i;

function fileExtension(name) {
  const base = String(name || '').trim();
  const dot = base.lastIndexOf('.');
  if (dot <= 0 || dot === base.length - 1) return '';
  return base.slice(dot + 1).toLowerCase();
}

/**
 * @param {string} [mimeType]
 * @param {string} [name]
 */
export function resolveStorageBoxFileIcon(mimeType, name) {
  const mime = (mimeType || '').toLowerCase();
  const ext = fileExtension(name);

  if (ext && FILE_ICON_BY_EXTENSION[ext]) {
    return FILE_ICON_BY_EXTENSION[ext];
  }

  const officeKind = getOfficeDocumentKind(mimeType, name);
  if (officeKind === 'word') {
    return { Icon: FaFileWord, modifierClass: 'sb-drive-icon--word' };
  }
  if (officeKind === 'spreadsheet') {
    return { Icon: FaFileExcel, modifierClass: 'sb-drive-icon--spreadsheet' };
  }
  if (officeKind === 'presentation') {
    return { Icon: FaFilePowerpoint, modifierClass: 'sb-drive-icon--presentation' };
  }

  if (mime.includes('pdf') || ext === 'pdf') {
    return FILE_ICON_BY_EXTENSION.pdf;
  }

  if (mime === 'audio/mpeg' || mime === 'audio/mp3' || ext === 'mp3') {
    return FILE_ICON_BY_EXTENSION.mp3;
  }

  if (mime.startsWith('audio/') || AUDIO_EXT.test(name || '')) {
    return { Icon: FaFileAudio, modifierClass: 'sb-drive-icon--audio' };
  }

  if (
    mime.startsWith('video/') ||
    mime.includes('quicktime') ||
    VIDEO_EXT.test(name || '')
  ) {
    return { Icon: FaFileVideo, modifierClass: 'sb-drive-icon--video' };
  }

  if (mime.startsWith('image/') || IMAGE_EXT.test(name || '')) {
    return { Icon: FaFileImage, modifierClass: 'sb-drive-icon--image' };
  }

  if (mime.includes('zip') || mime.includes('compressed') || mime.includes('archive')) {
    return { Icon: FaFileZipper, modifierClass: 'sb-drive-icon--archive' };
  }

  if (
    mime.startsWith('text/') ||
    mime.includes('javascript') ||
    mime.includes('json') ||
    mime.includes('xml')
  ) {
    if (mime.includes('html')) return FILE_ICON_BY_EXTENSION.html;
    if (mime.includes('css')) return FILE_ICON_BY_EXTENSION.css;
    if (mime.includes('json')) return FILE_ICON_BY_EXTENSION.json;
    if (mime.includes('xml')) return FILE_ICON_BY_EXTENSION.xml;
    return { Icon: FaFileLines, modifierClass: 'sb-drive-icon--text' };
  }

  return DEFAULT_FILE;
}
